import {Box, VStack} from 'platform/foundation';

import {MakeAndChecked} from '../utils/types';
import {TopMakeRow, TopMakeRowProps} from './TopMakeRow';

interface TopMakesListProps {
  readonly makeOptions: MakeAndChecked[];
  readonly handleRowToggle: TopMakeRowProps['handleRowToggle'];
}

export const TopMakesList = ({makeOptions, handleRowToggle}: TopMakesListProps) => (
  <Box paddingTop={4}>
    <VStack spacing={4}>
      {makeOptions.map((make, i) => (
        <TopMakeRow
          data-testid={`${make.value}-row`}
          key={`${make.value}-${i}`} // eslint-disable-line react/no-array-index-key -- Pre-existing violation
          make={make}
          handleRowToggle={handleRowToggle}
        />
      ))}
    </VStack>
  </Box>
);
